import Account from "../pages/account/Account";
import Orders from "../pages/orders/Orders";

const customerRoutes = [
  { path: "/customer/orders", component: Orders },
  { path: "/customer/account", component: Account },
];

export default customerRoutes;
